import { Col } from "reactstrap";
import {CURRANCES_DATA} from "../../../../Data/Widgets/GeneralWidgets"
import CommonCurrencyWidget from "../../Common/CommonCurrencyWidget";

const CurrencyWidget = () => {
  return (
    <>
      {CURRANCES_DATA.map((item, index) => (
        <Col key={index} sm="4" xl="2" className="p-2">
          <CommonCurrencyWidget data={item} />
        </Col>
      ))}
    </>
  );
};

export default CurrencyWidget;
